module.exports = __webpack_public_path__ + "b67d02d53b45d4b83e2417e1ce880979.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/school-girl-uniform.png
// module id = 1935
// module chunks = 0